import { Link } from "react-router-dom";
import { Phone, MessageSquare, FileText, Bot } from "lucide-react";
import { TEL, SMS } from "@/lib/config";
import { openGhost } from "./GhostAI";

export const MobileBar = () => (
  <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 card-shadow-lg"
       data-testid="mobile-bottom-bar">
    <div className="grid grid-cols-4">
      <a href={TEL} data-testid="mobilebar-call" className="flex flex-col items-center gap-1 py-2.5 text-[var(--navy)] active:bg-gray-50">
        <Phone className="w-5 h-5 text-[var(--red)]" /><span className="text-[10px] font-semibold">Call</span>
      </a>
      <a href={SMS} data-testid="mobilebar-text" className="flex flex-col items-center gap-1 py-2.5 text-[var(--navy)] active:bg-gray-50">
        <MessageSquare className="w-5 h-5 text-[var(--action)]" /><span className="text-[10px] font-semibold">Text</span>
      </a>
      <Link to="/get-a-quote" data-testid="mobilebar-quote" className="flex flex-col items-center gap-1 py-2.5 text-[var(--navy)] active:bg-gray-50">
        <FileText className="w-5 h-5 text-[var(--bright)]" /><span className="text-[10px] font-semibold">Free Quote</span>
      </Link>
      <button onClick={openGhost} data-testid="mobilebar-ghost" className="flex flex-col items-center gap-1 py-2.5 text-[var(--navy)] active:bg-gray-50">
        <Bot className="w-5 h-5 text-[var(--navy)]" /><span className="text-[10px] font-semibold">Ghost AI</span>
      </button>
    </div>
  </div>
);
